import { render, staticRenderFns } from "./CreateLiveAccount.vue?vue&type=template&id=77259cf6&scoped=true"
import script from "./CreateLiveAccount.vue?vue&type=script&lang=js"
export * from "./CreateLiveAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateLiveAccount.vue?vue&type=style&index=0&id=77259cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77259cf6",
  null
  
)

export default component.exports